import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { kyrgyzstanSearchStore } from 'entities/kyrgyzstan'
import { SearchFormKyrgyzstan } from 'entities/kyrgyzstan/ui'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const KyrgyzstanSearchFormPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleSearch = () => {
    kyrgyzstanSearchStore.reset()
    kyrgyzstanSearchStore.resetFilters()
    navigate(RoutingPaths.kyrgyzstan.searchResult.path())
  }

  return (
    <div className={s.container}>
      <HeaderGoBack
        variant="grey"
        title={t('kyrgyzstan_block.search_form.edit_page_title')}
        onGoBack={handleGoBack}
        buttonWhite
      />

      <SearchFormKyrgyzstan onSearch={handleSearch} />
    </div>
  )
})

export default KyrgyzstanSearchFormPage
